<script lang="ts">
import AppIcon from '@/components/icons/AppIcon.vue'
import type { TIconValue } from '@/utils/helper-objects'
import { type PropType, defineComponent } from 'vue'

import { NamedThemeColors, type TNamedThemeColorValue } from '../theme/main'

/**
 * A component for rendering a colourizsed badge contaning an icon
 *
 * @example
 * ```
 * <IconBadge :icon="Icons.Ticket" :color="NamedThemeColors.Primary" />
 * ```
 */
export default defineComponent({
  components: { AppIcon },
  props: {
    icon: {
      type: String as PropType<TIconValue>,
      required: true,
    },
    color: {
      type: String as PropType<TNamedThemeColorValue>,
    },
  },
  setup() {
    return {
      NamedThemeColors,
    }
  },
})
</script>

<template>
  <span
    class="badge block rounded-md p-2 leading-none"
    :class="{
      'bg-primary-lighter text-primary': color === NamedThemeColors.Primary,
      'bg-green-200 text-green-500': color === NamedThemeColors.Secondary,
      'bg-orange-200 text-orange-500': color === NamedThemeColors.Tertiary,
      'bg-[#E9F5FB] text-[#5F7D92]': color === NamedThemeColors.Neutral,
      'bg-black text-white': color === NamedThemeColors.Monochrome,
    }"
  >
    <AppIcon :icon />
  </span>
</template>
